import i18n from '@/locale/i18n'

import birthday from '@/page/birthday/index'
import birthdaySuccess from '@/page/birthday/success'
import birthdayshare from '@/page/birthday/birthdayshare'
import birthdaysend from '@/page/birthday/birthdaysend'
import login from '@/page/birthday/login'
import home from '@/page/birthday/home'
import rule from '@/page/birthday/rule'

export default [
  {
    path: '/birthday',
    component: birthday,
    meta: { title: i18n.t('birthday.birthday26') }
  },
  {
    path: '/birthdaySuccess',
    component: birthdaySuccess,
    meta: { title: i18n.t('easter.title2') }
  },
  {
    path: '/birthdayshare',
    component: birthdayshare,
    meta: { title: i18n.t('birthday.birthday26') }
  },
  {
    path: '/birthdaysend/:index',
    component: birthdaysend,
    meta: { title: i18n.t('birthday.birthday26') }
  },
  {
    path: '/login',
    component: login,
    meta: { title: '登录校验' }
  },
  {
    path: '/birthdayHome',
    component: home,
    meta: { title: i18n.t('birthday.birthday26') }
  },
  {
    path: '/rule',
    component: rule,
    meta: { title: i18n.t('birthday.birthday33') }
  }
]



// WEBPACK FOOTER //
// ./src/router/birthday/index.js